import { render } from "./StoreNotActive.vue?vue&type=template&id=770c3679"
import script from "./StoreNotActive.vue?vue&type=script&lang=js"
export * from "./StoreNotActive.vue?vue&type=script&lang=js"

import "./StoreNotActive.vue?vue&type=style&index=0&id=770c3679&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QBtn});
